import { render } from "./TimelineContent.vue?vue&type=template&id=b1c4f596"
import script from "./TimelineContent.vue?vue&type=script&lang=js"
export * from "./TimelineContent.vue?vue&type=script&lang=js"

import "./TimelineContent.vue?vue&type=style&index=0&id=b1c4f596&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__